module.exports = __webpack_public_path__ + "img/reci.pt.8e497b9e.png";